import React from 'react';

import { FontAwesomeIcon, Badge, Tooltip } from '@schoolinks/ui-components';
import { node, string, shape, number, bool } from 'prop-types';

import { NavLink } from 'react-router-dom';

import { NAV_MENU_ICON_PROPS } from 'components/Common/LayoutV2/constants';

import { isAbsoluteLink } from 'utils/urls';

import s from './AppbarLink.module.css';

const AppbarLink = ({
  'aria-label': ariaLabel,
  icon,
  href,
  badgeCount,
  disabled,
  tooltip,
}) => {
  const LinkComponent = isAbsoluteLink(href) ? 'a' : NavLink;
  const linkProps = isAbsoluteLink(href)
    ? {
        href: disabled ? '' : href,
        rel: 'noopener noreferrer',
        target: '_blank',
      }
    : { to: disabled ? '' : href };
  return (
    <Tooltip title={tooltip} placement="bottom">
      <LinkComponent aria-label={ariaLabel} className={s.root} {...linkProps}>
        {badgeCount ? (
          <Badge
            color="critical"
            number={badgeCount}
            classes={{ root: s.badge }}
          />
        ) : null}
        <FontAwesomeIcon icon={icon} {...NAV_MENU_ICON_PROPS} />
      </LinkComponent>
    </Tooltip>
  );
};

AppbarLink.propTypes = {
  'aria-label': string.isRequired,
  icon: node.isRequired,
  href: string,
  tooltipProps: shape({}),
  badgeCount: number,
  disabled: bool,
  tooltip: string,
};

AppbarLink.defaultProps = {
  href: undefined,
  tooltipProps: undefined,
  badgeCount: undefined,
  disabled: false,
  tooltip: '',
};

export default AppbarLink;
